import { render } from "./TestSafeAreasView.vue?vue&type=template&id=0174914a&scoped=true"
import script from "./TestSafeAreasView.vue?vue&type=script&lang=js"
export * from "./TestSafeAreasView.vue?vue&type=script&lang=js"

import "./TestSafeAreasView.vue?vue&type=style&index=0&id=0174914a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0174914a"]])

export default __exports__